import ApplicationController from './application_controller'

class HcaptchaController extends ApplicationController {
  static targets = ['widget']
  static values = { resource: String }

  connect () {
    if (this.resourceValue === 'User') return

    window.hcaptchaOnLoad = function () { }
    document.addEventListener('shown.bs.tab', () => this.tryRender())
    this.tryRender()
  }

  disconnect () {
    delete window.hcaptchaOnLoad
    document.removeEventListener('shown.bs.tab')
  }

  tryRender (attempts = 0) {
    if (window.hcaptcha) {
      this.render()
    } else if (attempts < 5) {
      setTimeout(() => this.tryRender(attempts + 1), 100)
    } else {
      console.error('Undefined hCaptcha')
    }
  }

  render () {
    if (!window.hcaptcha) return

    this.widgetTargets.forEach(el => {
      if (el.dataset.rendered) return

      window.hcaptcha.render(el)
      el.dataset.rendered = 'true'
    })
  }
}

export default HcaptchaController
